import React, { useState, useEffect } from 'react';
import { faAngleLeft, faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Col, Row } from 'reactstrap';

//Helpers
import { getSessionCookie } from '../../../../../helpers/cookies';
import { objCampo, validarCampos } from '../../../../../helpers/ValidadorDeCampos';
import { showMessage } from '../../../../../helpers/message';

//Components
import MainCard from '../../../../../components/MainCard';
import TextField from '../../../../../components/TextField';
import MapaPlanoTrabalho from './MapaPlanoTrabalho';

//API
import planoTrabalho_api from '../../../../../api/planoTrabalho_api';
import contratadas_api from '../../../../../api/contratadas_api';

//Context
import { useAuth } from '../../../../../context/auth';

function initialStatePlanoTrabalho(secretaria_Id) {
    return {
        identificacao: "",
        contratada_Id: "",
        status: "Ativo",
        secretaria_Id: secretaria_Id,
        frequencia: "Diario",
        calendarioExecucao: [],
        planoTrabalhoLocais: []
    }
}
//[Frequencia]='Diario' OR [Frequencia]='Semanal' OR [Frequencia]='Avulso' OR [Frequencia]='Quinzenal' OR [Frequencia]='Mensal'
function CadastroPlanoTrabalho({ id, handleVoltar, editavel }) {
    // Objeto
    const session = getSessionCookie();

    const { setLoading } = useAuth();

    //State para criar/editar plano trabalho
    const [planoTrabalho, setPlanoTrabalho] = useState(initialStatePlanoTrabalho(session.secretaria_Id));

    //State para pegar lista contratadas
    const [listContratadas, setListContratadas] = useState([]);

    //State para pegar erros
    const [errors, setErrors] = useState({});

    const loadContratadas = () => {
        setLoading(true);
        contratadas_api.getList()
            .then(response => setListContratadas(response.data))
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false));
    }

    const loadPlanoTrabanho = (id = null) => {
        if (id != null || planoTrabalho?.id != null) {
            setLoading(true);
            planoTrabalho_api.getItem(planoTrabalho?.id ?? id)
                .then(response => {
                    if (response?.data?.contratada_Id){
                        response.data.contratada_Id = response.data.contratada_Id.toString();
                    }
                        
                    if (response?.data?.calendarioExecucao){
                        response.data.calendarioExecucao = response.data.calendarioExecucao.split("|");
                    }
                        
                    setPlanoTrabalho(response.data)
                })
                .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
                .finally(() => setLoading(false));
        }
    }

    useEffect(() => {
        loadContratadas();
        loadPlanoTrabanho(id);
    }, []);

    //Campos obrigatorios
    const campos = [
        objCampo({ name: "identificacao", required: true }),
        objCampo({ name: "contratada_Id", required: true })
    ];

    const [semanas, setSemanas] = useState([
        { value: "Segunda", label: "Segunda" },
        { value: "Terça", label: "Terça" },
        { value: "Quarta", label: "Quarta" },
        { value: "Quinta", label: "Quinta" },
        { value: "Sexta", label: "Sexta" },
    ])

    const [mensal, setMensal] = useState([
        { value: "1", label: "1" },
        { value: "2", label: "2" },
        { value: "3", label: "3" },
        { value: "4", label: "4" },
        { value: "5", label: "5" },
        { value: "6", label: "6" },
        { value: "7", label: "7" },
        { value: "8", label: "8" },
        { value: "9", label: "9" },
        { value: "10", label: "10" },
        { value: "11", label: "11" },
        { value: "12", label: "12" },
        { value: "13", label: "13" },
        { value: "14", label: "14" },
        { value: "15", label: "15" },
        { value: "16", label: "16" },
        { value: "17", label: "17" },
        { value: "18", label: "18" },
        { value: "19", label: "19" },
        { value: "20", label: "20" },
        { value: "21", label: "21" },
        { value: "22", label: "22" },
        { value: "23", label: "23" },
        { value: "24", label: "24" },
        { value: "25", label: "25" },
        { value: "26", label: "26" },
        { value: "27", label: "27" },
        { value: "28", label: "28" },
        { value: "29", label: "29" },
        { value: "30", label: "30" },
        { value: "31", label: "31" }
    ]);

    //onChange para os multiSelects
    const onChangeMultiSelect = (e, select) => {
        const { name } = select;
        setPlanoTrabalho({
            ...planoTrabalho,
            [name]: e && e.length > 0 ? e.map(value => value.value) : []
        })
    }


    //Função para campos select
    const onChangeContratada = (value, e) => {
        setPlanoTrabalho({
            ...planoTrabalho,
            [e.name]: value ? value.value : null,
        });
    }

    const onChange = (e) => {
        const { name, value } = e.target;
        const _planoTrabalho = {
            ...planoTrabalho,
            [name]: value
        };

        //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
        const _campos = campos.filter(campo => campo.name === name);
        const fieldError = validarCampos(_planoTrabalho, _campos);

        const _errors = { ...errors };
        delete _errors[name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setPlanoTrabalho(_planoTrabalho);
    }

    const onChangeTipoFrequencia = (e) => {
        const { name, value } = e.target;
        if (name == "Diario" || name == "Avulso") {
            setPlanoTrabalho({
                ...planoTrabalho,
                [name]: value,
                calendarioExecucao: []
            })
        } else {
            setPlanoTrabalho({
                ...planoTrabalho,
                [name]: value,
                calendarioExecucao: []
            })
        }
    }

    const onSumitPlanoTrabalho = () => {
        const _errors = validarCampos(planoTrabalho, campos);
        setErrors(_errors[0]);


        if (_errors[1].length > 0)
            return true;

        const _planoTrabalho = { ...planoTrabalho };
        _planoTrabalho.calendarioExecucao = _planoTrabalho?.calendarioExecucao?.length > 0 ? _planoTrabalho.calendarioExecucao.join("|") : null;

        if (_planoTrabalho.id) {
            setLoading(true);
            planoTrabalho_api.put(_planoTrabalho)
                .then(response => showMessage("Sucesso", "Sucesso na operação.", "success", handleVoltar))
                .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
                .finally(() => setLoading(false));
        } else {
            setLoading(true);
            planoTrabalho_api.post(_planoTrabalho)
                .then(response => showMessage("Sucesso", "Sucesso na operação.", "success", handleVoltar))
                .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
                .finally(() => setLoading(false));
        }
    }

    return <>
        <Button onClick={() => {
            handleVoltar()
        }} className='px-4'>
            <FontAwesomeIcon icon={faAngleLeft} className='me-2' />
            Voltar
        </Button>
        <MainCard>
            <h5 style={{ color: "#666" }}>Cadastro de Plano Trabalho</h5>
            <Row>
                <Col md={12} lg={5} style={{ zIndex: "" }}>
                    <TextField
                        name={"contratada_Id"}
                        label={"* Contratada"}
                        type={"select"}
                        searchable
                        options={listContratadas.map(v => { return { value: v.id.toString(), label: v.razaoSocial } })}
                        value={
                            listContratadas.filter(v => v.id == planoTrabalho.contratada_Id)
                                .map(v => { return { value: v.id.toString(), label: v.razaoSocial } })
                        }
                        onChange={onChangeContratada}
                        maxLength={100}
                        disabled={!editavel}
                        invalid={!!errors.contratada_Id}
                    />
                </Col>
                <Col md={12} lg={5}>
                    <TextField
                        name={"identificacao"}
                        label={"* Identificação"}
                        type={"text"}
                        value={planoTrabalho.identificacao}
                        onChange={onChange}
                        maxLength={300}
                        invalid={errors.identificacao}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={2}>
                    <TextField
                        name={"status"}
                        label={"* Status"}
                        type={"select"}
                        options={[
                            { value: "Ativo", label: "Ativo" },
                            { value: "Inativo", label: "Inativo" }
                        ]}
                        value={planoTrabalho.status}
                        onChange={onChange}
                        maxLength={7}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={3}>
                    <TextField
                        name={"frequencia"}
                        label={"* Frequência"}
                        type={"select"}
                        options={[
                            { value: "Diario", label: "Diário" },
                            { value: "Semanal", label: "Semanal" },
                            { value: "Avulso", label: "Avulso" },
                            { value: "Mensal", label: "Mensal" }
                        ]}
                        value={planoTrabalho.frequencia}
                        onChange={onChangeTipoFrequencia}
                        maxLength={15}
                        disabled={!editavel}
                    />
                </Col>
                {planoTrabalho.frequencia != "Diario" && planoTrabalho.frequencia != "Avulso" && planoTrabalho.frequencia == "Semanal" &&
                    <Col md={12} lg={9}>
                        <TextField
                            name={"calendarioExecucao"}
                            label={"Calendário de execução"}
                            multiple
                            type={"select"}
                            value={
                                semanas.filter(c => planoTrabalho?.calendarioExecucao?.some(s => s == c.value))
                                    .map(v => v)
                            }
                            options={
                                semanas.filter(c => !planoTrabalho?.calendarioExecucao?.some(s => s == c.value))
                                    .map(v => v)
                            }
                            onChange={onChangeMultiSelect}
                            disabled={!editavel}
                        />
                    </Col>
                }
                {planoTrabalho.frequencia != "Diario" && planoTrabalho.frequencia != "Avulso" && planoTrabalho.frequencia == "Mensal" &&
                    <Col md={12} lg={9}>
                        <TextField
                            name={"calendarioExecucao"}
                            label={"Calendário de execução"}
                            multiple
                            type={"select"}
                            value={
                                mensal.filter(c => planoTrabalho?.calendarioExecucao?.some(s => s == c.value))
                                    .map(v => v)
                            }
                            options={
                                mensal.filter(c => !planoTrabalho?.calendarioExecucao?.some(s => s == c.value))
                                    .map(v => v)
                            }
                            onChange={onChangeMultiSelect}
                            disabled={!editavel}
                        />
                    </Col>
                }

            </Row>

            <Row className='px-3'>
                <Col md="12" lg="12" className="rounded overflow-hidden p-0" style={{ zIndex: "0" }} >
                    <MapaPlanoTrabalho
                        planoTrabalho={planoTrabalho}
                        setPlanoTrabalho={setPlanoTrabalho}
                        editavel={editavel}
                    />
                </Col>
            </Row>

            <Row className='mt-4'>
                <Col md="12" lg="12" className={`d-flex align-items-center justify-content-center ${editavel ? "" : "d-none"}`}>
                    <Button
                        className='px-4'
                        color={planoTrabalho.id ? 'warning text-white' : 'success'}
                        onClick={onSumitPlanoTrabalho}>{planoTrabalho.id ? <><FontAwesomeIcon icon={faEdit} /> Atualizar</> : "+ Cadastrar"}
                    </Button>
                </Col>
            </Row>

        </MainCard>
    </>;
}

export default CadastroPlanoTrabalho;